import React, { useEffect, useState } from "react";
import TrackOfTheDayResults from "./TrackOfTheDayResults";
import OfTheDayResults from "./OfTheDayResults";
import SleeveryResults from "./SleeveryResults";
import GeneralResults from "./GeneralResults";
import KindBudAssist from "../Components/Global/KindBudAssist";
import NoResults from "./NoResults";
import InterviewResults from "./InterviewResults";
import MotwResults from "./MotwResults";

const HomePage = ({ history }) => {
  const search = window.location.search;
  const query = new URLSearchParams(search);

  let [searchTerm, setSearchTerm] = useState(query.get("q") || null);
  let [results, setResults] = useState(null);

  const submitSearch = () => {
    if (searchTerm) {
      history.push("?q=" + searchTerm);

      const escapedQueryString = encodeURIComponent(searchTerm);
      fetch(`https://www.dreamchimney.com/api/search?terms=${escapedQueryString}`)
        .then((response) => response.json())
        .then((data) => setResults(data.results));
    }
  };

  useEffect(() => {
    submitSearch();
  }, []);

  return (
    <div>
      <div className="home-page-component">
        <div className="head-component">
          <div className="resultsGroupHeader">
            <div className="text-center">Enter some text below to find things on Dream Chimney.</div>
          </div>
          <form
            class="form-inline"
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch();
            }}
          >
            <div class="form-group col-sm-10">
              <input
                type="text"
                id="searchTerm"
                style={{ width: "100%" }}
                className="form-control"
                placeholder=""
                required
                value={searchTerm}
                autocomplete="off"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div class="form-group col-sm-2">
              <button type="button" className="btn btn-dark mb-2" onClick={() => submitSearch()}>
                Search
              </button>
            </div>
          </form>
        </div>
        <div className="body-component">
          {searchTerm && results && (
            <div className="resultsGroupHeader searchResultsHeader">

              <div style={{ color: '#000', fontSize: 14, paddingLeft: 20 }} className="text-center">Below are some related items we found...</div>
            </div>
          )}
          <NoResults results={results} />


          <TrackOfTheDayResults results={results} searchTerm={searchTerm} />

          <MotwResults results={results} searchTerm={searchTerm} />
          <InterviewResults results={results} searchTerm={searchTerm} />
          <SleeveryResults results={results} searchTerm={searchTerm} />
          <OfTheDayResults results={results} searchTerm={searchTerm} />

          <GeneralResults results={results} searchTerm={searchTerm} />

          <div className={searchTerm && results ? `kba-footer-results` : `kba-footer`}>
            <KindBudAssist />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
